import { combineReducers } from '@reduxjs/toolkit'

import leaveRequestReducer from './leave-request'
import leaveRequestTypeReducer from './leave-request-type'
import leaveRequestRolloverReducer from './leave-request-rollover'
import punchRecordsReducer from './punch-records'
import punchRequestReducer from './punch-request'

const combinedReducer = combineReducers({
  leaveRequest: leaveRequestReducer,
  leaveRequestType: leaveRequestTypeReducer,
  leaveRequestRollover: leaveRequestRolloverReducer,
  punchRecords: punchRecordsReducer,
  punchRequest: punchRequestReducer,
})

export default combinedReducer